/**
 * Copy text to the clipboard using the modern async API.
 * Returns a promise that resolves true on success, false on failure.
 * No legacy execCommand fallback — all supported browsers (Chrome/Edge/Firefox/Safari
 * from 2018 onwards) expose navigator.clipboard on secure origins (https/localhost).
 */
export function copyToClipboard(text) {
  if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText) {
    return Promise.resolve(false);
  }
  return navigator.clipboard.writeText(text).then(
    () => true,
    () => false,
  );
}
